
import Vue from "vue";
import Component from "vue-class-component";

import ResponsiveIconButton from "@/components/basic/ResponsiveIconButton.vue";
import { Property } from "@/property/shared/dtos/Property";

@Component<CreateAssignmentButton>({
  components: {
    ResponsiveIconButton
  },
  props: {
    plantType: {
      type: String,
      default: undefined
    }
  }
})
export default class CreateAssignmentButton extends Vue {
  protected dropDownVisible = false;
  protected plantType!: string;

  protected get selectedProperties(): Property[] {
    return this.$store.getters.getSelectedProperties || [];
  }

  protected get hasSingleProperty() {
    return this.selectedProperties.length === 1;
  }

  protected get hasMultipleProperties() {
    return this.selectedProperties.length > 1;
  }

  protected get firstProperty() {
    return this.selectedProperties[0];
  }

  protected toggleDropdownOrSelectFirstProperty() {
    if (!this.plantType) {
      this.goToPlantsListPage();
      return;
    }

    const firstProperty = this.firstProperty;

    if (this.hasSingleProperty && firstProperty) {
      this.goToNewAssignmentPage(firstProperty.id.toString());
    } else if (this.hasMultipleProperties) {
      this.dropDownVisible = !this.dropDownVisible;
    } else {
      this.goToPlantsListPage();
    }
  }

  protected goToNewAssignmentPage(propertyId: string) {
    this.$router.push({
      name: "assignment",
      query: {
        propertyId,
        checklistTemplate: this.plantType
      }
    });
  }

  protected toPropertyAddress(property: Property) {
    return `${property.street}, ${property.zip} ${property.city}`;
  }

  protected goToPlantsListPage() {
    this.$router.push({ name: "plants" });
  }
}
